"use strict";
// packages/types/src/xero-transactions.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionSource = exports.AllocationStatus = exports.XeroAccountType = exports.XeroBankTransactionStatusCodes = exports.XeroTransactionType = exports.XeroAmountType = void 0;
var XeroAmountType;
(function (XeroAmountType) {
    XeroAmountType["INCLUSIVE"] = "Inclusive";
    XeroAmountType["EXCLUSIVE"] = "Exclusive";
    XeroAmountType["NONE"] = "NoTax";
})(XeroAmountType || (exports.XeroAmountType = XeroAmountType = {}));
var XeroTransactionType;
(function (XeroTransactionType) {
    XeroTransactionType["SPEND"] = "SPEND";
    XeroTransactionType["RECEIVE"] = "RECEIVE";
    XeroTransactionType["TRANSFER"] = "TRANSFER";
    XeroTransactionType["SPEND_OVERPAYMENT"] = "SPEND-OVERPAYMENT";
    XeroTransactionType["RECEIVE_OVERPAYMENT"] = "RECEIVE-OVERPAYMENT";
    XeroTransactionType["SPEND_PREPAYMENT"] = "SPEND-PREPAYMENT";
    XeroTransactionType["RECEIVE_PREPAYMENT"] = "RECEIVE-PREPAYMENT";
    XeroTransactionType["RECEIVE_TRANSFER"] = "RECEIVE-TRANSFER";
    XeroTransactionType["SPEND_TRANSFER"] = "SPEND-TRANSFER";
})(XeroTransactionType || (exports.XeroTransactionType = XeroTransactionType = {}));
var XeroBankTransactionStatusCodes;
(function (XeroBankTransactionStatusCodes) {
    XeroBankTransactionStatusCodes["AUTHORISED"] = "AUTHORISED";
    XeroBankTransactionStatusCodes["DELETED"] = "DELETED";
    // Used by BILL rows (Xero Invoice statuses). Bank transactions never carry these.
    XeroBankTransactionStatusCodes["PAID"] = "PAID";
    XeroBankTransactionStatusCodes["SUBMITTED"] = "SUBMITTED";
    XeroBankTransactionStatusCodes["VOIDED"] = "VOIDED";
    XeroBankTransactionStatusCodes["DRAFT"] = "DRAFT";
})(XeroBankTransactionStatusCodes || (exports.XeroBankTransactionStatusCodes = XeroBankTransactionStatusCodes = {}));
var XeroAccountType;
(function (XeroAccountType) {
    XeroAccountType["ASSET"] = "ASSET";
    XeroAccountType["EQUITY"] = "EQUITY";
    XeroAccountType["EXPENSE"] = "EXPENSE";
    XeroAccountType["LIABILITY"] = "LIABILITY";
    XeroAccountType["REVENUE"] = "REVENUE";
})(XeroAccountType || (exports.XeroAccountType = XeroAccountType = {}));
var AllocationStatus;
(function (AllocationStatus) {
    AllocationStatus["PENDING"] = "PENDING";
    AllocationStatus["ALLOCATED"] = "ALLOCATED";
    AllocationStatus["EXCLUDED"] = "EXCLUDED";
})(AllocationStatus || (exports.AllocationStatus = AllocationStatus = {}));
/**
 * Source of a transaction row.
 * - BANK_TXN:     ingested from Xero `/BankTransactions` (Type=SPEND), i.e. "Spend Money" entries
 * - BILL:         ingested from Xero `/Invoices` (Type=ACCPAY), i.e. accounts payable Bills
 * - SELF_INVOICE: ingested from Xero `/Invoices` filtered to the org's self-contact —
 *                 a "self-referencing invoice journal" used to shift costs between accounts.
 *                 Opt-in per organisation (`selfInvoicesEnabled` + `selfXeroContactId`).
 */
var TransactionSource;
(function (TransactionSource) {
    TransactionSource["BANK_TXN"] = "BANK_TXN";
    TransactionSource["BILL"] = "BILL";
    TransactionSource["SELF_INVOICE"] = "SELF_INVOICE";
})(TransactionSource || (exports.TransactionSource = TransactionSource = {}));
